import { gql } from "@apollo/client";

export const GET_EXPORTACION_AUTORIZACIONES = gql`
query exportarAutorizacionesCambioPrecio($filter: AutorizacionCambioPrecioFilterInput!) {
    exportarAutorizacionesCambioPrecio(filter: $filter) {
        success
        error
        valorEsperado {
            idAutorizacionPrecioMasivo
            delegacion
            fecha
            solicitante
            idEvaluacion
            planCuidado
            codigoPlan
            financiador
            periodo
            precioACambiar
            precioActual
            precioControl
            precioSAP
            viable
            estado
        }
    }
}`;